<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import city from "../../helpers/list/city.json";

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      establishment_date: "",
      project_name: "",
      project_sector: "",
      project_summary: "",
      governorate: "",
      governorates: city,
      region: "",
      instagram: "",
      facebook: "",
      tiktok: "",
      notes: "",
    };
  },
  validations: {
    establishment_date: {
      required,
      notFuture: (value) => {
        if (!value) return true;

        const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value);
        if (!match) return false;

        const [, day, month, year] = match.map(Number);
        const date = new Date(year, month - 1, day);
        const today = new Date();

        return (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day &&
          date <= new Date(today.getFullYear(), today.getMonth(), today.getDate())
        );
      },
    },
    project_name: { required, minLength: minLength(2), maxLength: maxLength(250) },
    project_sector: { required, minLength: minLength(2), maxLength: maxLength(250) },
    project_summary: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(1000),
    },
    governorate: { required },
    region: { required, minLength: minLength(2), maxLength: maxLength(50) },
    instagram: {
      minLength: minLength(2),
      maxLength: maxLength(500),
      atLeastOneSocialLink: (value, vm) =>
        [value, vm && vm.facebook, vm && vm.tiktok].some(
          (link) => typeof link === "string" && link.trim().length > 0
        ),
    },
    facebook: { minLength: minLength(2), maxLength: maxLength(500) },
    tiktok: { minLength: minLength(2), maxLength: maxLength(500) },
    notes: { minLength: minLength(2), maxLength: maxLength(1000) },

    form: [
      "establishment_date",
      "project_name",
      "project_sector",
      "project_summary",
      "governorate",
      "region",
      "instagram",
      "facebook",
      "tiktok",
      "notes",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    chnageFile(e) {
      this[e.target.id] = e.target.files.length > 0 ? e.target.files[0] : null;
    },
    isFutureDate(date) {
      const today = new Date();
      return (
        date.getFullYear() > today.getFullYear() ||
        (date.getFullYear() === today.getFullYear() &&
          date.getMonth() > today.getMonth()) ||
        (date.getFullYear() === today.getFullYear() &&
          date.getMonth() === today.getMonth() &&
          date.getDate() > today.getDate())
      );
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <b-form-group
        class="col-md-4 mb-3"
        label=" اسم المشروع : "
        label-for="project_name"
      >
        <b-form-input
          id="project_name"
          type="text"
          placeholder="ادخل اسم المشروع"
          v-model="project_name"
          :class="{ 'is-invalid': $v.project_name.$error }"
        ></b-form-input>
        <div v-if="$v.project_name.$error" class="invalid-feedback">
          <span v-if="!$v.project_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.project_name.minLength"
            >يجب أن يتكون اسم المشروع من حرفين على الأقل</span
          >
          <span v-if="!$v.project_name.maxLength"
            >يجب أن يتكون اسم المشروع من 250 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label=" قطاع المشروع : "
        label-for="project_sector"
      >
        <b-form-input
          id="project_sector"
          type="text"
          placeholder="ادخل قطاع المشروع"
          v-model="project_sector"
          :class="{ 'is-invalid': $v.project_sector.$error }"
        ></b-form-input>
        <div v-if="$v.project_sector.$error" class="invalid-feedback">
          <span v-if="!$v.project_sector.required">هذا الحقل الزامي</span>
          <span v-if="!$v.project_sector.minLength"
            >يجب أن يتكون قطاع المشروع من حرفين على الأقل</span
          >
          <span v-if="!$v.project_sector.maxLength"
            >يجب أن يتكون قطاع المشروع من 250 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="تاريخ تأسيس المشروع : "
        label-for="establishment_date"
      >
        <date-picker
          id="establishment_date"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ تأسيس المشروع"
          :disabled-date="isFutureDate"
          v-model="establishment_date"
          :class="{ 'is-invalid': $v.establishment_date.$error }"
        ></date-picker>
        <div v-if="$v.establishment_date.$error" class="invalid-feedback">
          <span v-if="!$v.establishment_date.required">هذا الحقل الزامي</span>
          <span v-if="!$v.establishment_date.notFuture"
            >يجب ألا يتجاوز تاريخ التأسيس تاريخ اليوم</span
          >
        </div>
      </b-form-group>

      <b-form-group
        class="col-md-12 mb-3"
        label="ملخص المشروع :"
        label-for="project_summary"
      >
        <b-form-textarea
          id="project_summary"
          v-model="project_summary"
          rows="3"
          max-rows="6"
          placeholder="اكتب ملخصاً عن المشروع"
          :class="{ 'is-invalid': $v.project_summary.$error }"
        ></b-form-textarea>
        <div v-if="$v.project_summary.$error" class="invalid-feedback">
          <span v-if="!$v.project_summary.required">هذا الحقل الزامي</span>
          <span v-else-if="!$v.project_summary.minLength"
            >يجب أن يتكون ملخص المشروع من 5 أحرف على الأقل</span
          >
          <span v-else-if="!$v.project_summary.maxLength"
            >يجب ألا يتجاوز ملخص المشروع 1000 حرف</span
          >
        </div>
      </b-form-group>

      <b-form-group class="col-md-6 mb-3" label="المحافظة :" label-for="governorate">
        <select
          id="governorate"
          class="form-control"
          v-model="governorate"
          :class="{ 'is-invalid': $v.governorate.$error }"
        >
          <option value="">اختر المحافظة</option>
          <option v-for="city in governorates" :key="city.id" :value="city.id">
            {{ city.name }}
          </option>
        </select>
        <div v-if="$v.governorate.$error" class="invalid-feedback">
          <span v-if="!$v.governorate.required">يرجى اختيار المحافظة</span>
        </div>
      </b-form-group>

      <b-form-group class="col-md-6 mb-3" label="المنطقة :" label-for="region">
        <b-form-input
          id="region"
          v-model="region"
          type="text"
          placeholder="ادخل المنطقة"
          :class="{ 'is-invalid': $v.region.$error }"
        ></b-form-input>
        <div v-if="$v.region.$error" class="invalid-feedback">
          <span v-if="!$v.region.required">هذا الحقل الزامي</span>
          <span v-else-if="!$v.region.minLength"
            >يجب أن تتكون المنطقة من حرفين على الأقل</span
          >
          <span v-else-if="!$v.region.maxLength">يجب ألا تتجاوز المنطقة 50 حرفاً</span>
        </div>
      </b-form-group>

      <div class="col-12 mb-2">
        <small class="text-muted">
          أدخلي رابط الحساب كاملاً وليس المعرّف، ويجب إدخال رابط واحد على الأقل من منصات
          التواصل الثلاث.
        </small>
      </div>
      <b-form-group class="col-md-4 mb-3" label="انستكرام :" label-for="instagram">
        <b-form-input
          id="instagram"
          v-model="instagram"
          type="text"
          placeholder="https://www.instagram.com/..."
          :class="{ 'is-invalid': $v.instagram.$error }"
        ></b-form-input>
        <div v-if="$v.instagram.$error" class="invalid-feedback">
          <span v-if="!$v.instagram.minLength"
            >يجب أن يتكون الحساب من حرفين على الأقل</span
          >
          <span v-else-if="!$v.instagram.maxLength">يجب ألا يتجاوز الرابط 500 حرف</span>
          <span v-else-if="!$v.instagram.atLeastOneSocialLink"
            >أدخلي رابطاً واحداً على الأقل من حقول التواصل الاجتماعي</span
          >
        </div>
      </b-form-group>

      <b-form-group class="col-md-4 mb-3" label="فيس بوك :" label-for="facebook">
        <b-form-input
          id="facebook"
          v-model="facebook"
          type="text"
          placeholder="https://www.facebook.com/..."
          :class="{ 'is-invalid': $v.facebook.$error }"
        ></b-form-input>
        <div v-if="$v.facebook.$error" class="invalid-feedback">
          <span v-if="!$v.facebook.minLength"
            >يجب أن يتكون الرابط من حرفين على الأقل</span
          >
          <span v-else-if="!$v.facebook.maxLength">يجب ألا يتجاوز الرابط 500 حرف</span>
        </div>
      </b-form-group>

      <b-form-group class="col-md-4 mb-3" label="تيك توك :" label-for="tiktok">
        <b-form-input
          id="tiktok"
          v-model="tiktok"
          type="text"
          placeholder="https://www.tiktok.com/..."
          :class="{ 'is-invalid': $v.tiktok.$error }"
        ></b-form-input>
        <div v-if="$v.tiktok.$error" class="invalid-feedback">
          <span v-if="!$v.tiktok.minLength">يجب أن يتكون الرابط من حرفين على الأقل</span>
          <span v-else-if="!$v.tiktok.maxLength">يجب ألا يتجاوز الرابط 500 حرف</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-12 mb-3" label="الملاحظات :" label-for="notes">
        <b-form-textarea
          id="notes"
          v-model="notes"
          rows="3"
          max-rows="6"
          placeholder="أضف أي ملاحظات"
          :class="{ 'is-invalid': $v.notes.$error }"
        ></b-form-textarea>
        <div v-if="$v.notes.$error" class="invalid-feedback">
          <span v-if="!$v.notes.minLength"
            >يجب أن تتكون الملاحظات من حرفين على الأقل</span
          >
          <span v-else-if="!$v.notes.maxLength">يجب ألا تتجاوز الملاحظات 1000 حرف</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
